import { Constructor } from 'interfaces/constructor';
import ThreadEditorVM from './thread';

export interface ActivatableThreadEditor {
    activate: () => void
}

export function isActivatableThreadEditor(instance: any): instance is ActivatableThreadEditor {
    return instance instanceof ThreadEditorVM && 'activate' in instance;
}

export function MakeActivatable<TBase extends Constructor<any[], ThreadEditorVM<any>>>(Base: TBase) {
    abstract class Activatable extends Base implements ActivatableThreadEditor {
        isActive = ko.observable(false)

        activate = () => this.onActivate()

        constructor(...args: any[]) {
            super(...args);

            this.effects.register(thread => {
                if (thread != undefined)
                    this.isActive(true);
            }, [this.thread]);
        }

        protected override checkIfAllowedToCancel() {
            return super.checkIfAllowedToCancel() || this.isActive();
        }

        protected override finishEditing() {
            super.finishEditing();

            this.isActive(false);
        }

        protected onActivate() {
            this.isActive(true);
        }
    }

    return Activatable;
}